import React from 'react';

class AgendaHeader extends React.Component {
    getClass() {
        return `agenda-header ${this.props.display ? 'show' : ""}`
    }
    render() {
        return <div className={this.getClass()}>{this.props.title}</div>;
    }
}

AgendaHeader.defaultProps = {
    display: false
};

AgendaHeader.propTypes = {
    display: React.PropTypes.bool,
    title: React.PropTypes.string.isRequired
};

export default AgendaHeader;



/** WEBPACK FOOTER **
 ** ./app/src/components/AgendaHeader.js
 **/